interface DesktopProductImageProps {
  imageUrl?: string;
  productName: string;
}

export function DesktopProductImage({ imageUrl, productName }: DesktopProductImageProps) {
  return (
    <div className="w-full h-[500px] bg-gray-100 rounded-2xl overflow-hidden">
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={productName}
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center bg-gray-200">
          <span className="text-xl text-gray-500">이미지 없음</span>
        </div>
      )}
    </div>
  );
}